module.exports = __webpack_public_path__ + "img/tabbar_lightskin_3.dcc69112.png";